module.exports = __webpack_public_path__ + "img/openq.0cead713.png";